// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-indicator {
  display: inline-flex;
}

.loading-indicator-circle {
  display: flex;
  height: 24px;
  width: 24px;
  border-radius: 50%;
  background: var(--color-primary);

  :nth-child(n + 2) {
    margin-left: 2px;
  }

  & {
    animation: loading-indicator-expand 1.4s ease-in-out both infinite;
  }

  &:nth-child(2) {
    animation-delay: 0.2s;
  }

  &:nth-child(3) {
    animation-delay: 0.4s;
  }
}

@keyframes loading-indicator-expand {
  0%,
  50%,
  100% {
    -webkit-transform: scale(0);
  }

  50% {
    -webkit-transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/loadingIndicatorStyle.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gCAAgC;;EAEhC;IACE,gBAAgB;EAClB;;EAEA;IACE,kEAAkE;EACpE;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".loading-indicator {\n  display: inline-flex;\n}\n\n.loading-indicator-circle {\n  display: flex;\n  height: 24px;\n  width: 24px;\n  border-radius: 50%;\n  background: var(--color-primary);\n\n  :nth-child(n + 2) {\n    margin-left: 2px;\n  }\n\n  & {\n    animation: loading-indicator-expand 1.4s ease-in-out both infinite;\n  }\n\n  &:nth-child(2) {\n    animation-delay: 0.2s;\n  }\n\n  &:nth-child(3) {\n    animation-delay: 0.4s;\n  }\n}\n\n@keyframes loading-indicator-expand {\n  0%,\n  50%,\n  100% {\n    -webkit-transform: scale(0);\n  }\n\n  50% {\n    -webkit-transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
